import EventSelectFilter from "@/pages/dashboard/components/EventSelectFilter";
import { useLocal } from "@/pages/dashboard/utils/customHook";
import React from "react";

const formatEventData = (options: any) => (options || []).map((item: any) => {
  const { event_record: country, id: areaCode = '', name_cn: chText, name_en: enText } = item;
  return {
    region_abbre: areaCode || enText,
    region_key: areaCode || enText,
    region_name_cn: chText,
    // 临时处理。组件的翻译功能正在添加中，添加完后恢复原代码
    region_name_en: enText,
    // region_name_en: enText,
    country: (country || []).map((it: { event_type_name_en?: "" | undefined; event_title_cn: any; event_title_en: any; }) => {
      // const countryCode = uniqueId('event_type_id')
      // event_type_name_en如果为中文，那么作为id感觉不是很好所以这里用lodash生成一个id，后续如果涉及code对应的继承逻辑，则考虑是否用name作为code
      const { event_type_name_en: countryCode = '', event_title_cn: chText, event_title_en: enText } = it;
      // const { event_title_cn: chText, event_title_en: enText } = it;
      return {
        ...it,
        country_name_ch: chText,
        country_name_en: enText,
        chText,
        enText,
        // country_name_abbre: countryCode.toLowerCase(),
        country_name_abbre: countryCode,
        country_code: countryCode,
      };
    })
  };
});

const getItemsContain = (baseArr: any[], targetArr: string | any[]) => {
  const result:any = [];
  baseArr.forEach(item => {
    item.country.forEach((country: { value: string; }) => {
      if (targetArr.includes(country.value)) {
        if (!result.includes(item.region_name_en)) {
          result.push(item.region_name_en);
        }
      }
    });

    item.children.forEach((child: { value: string; }) => {
      if (targetArr.includes(child.value)) {
        if (!result.includes(item.region_name_en)) {
          result.push(item.region_name_en);
        }
      }
    });
  });

  return result;
};

export const EventSelectorFilter = (props: any): React.ReactElement => {
  const { value, options, eventLoading, onChange, eventError } = props || {};
  const { getLocalText, locale } = useLocal();
  return <div className='dbd-extral-filter dbd-extral-filter-event'>
    <EventSelectFilter
      className={'search-items-country dbd-search-items-event js-search-items-country'}
      value={value}
      eventLoading={eventLoading}
      eventError={eventError}
      onChange={(value, regionCountryOption) => {
        // 和后端沟通，参数不能是255，需要传空
        const eventNameVal = value?.markets?.length > 0 ? value?.markets : [];
        // const eventTypeVal = value?.regions?.length > 0 ? value?.regions : [];
        const newEventType = getItemsContain(regionCountryOption, eventNameVal);
        const newValue = {
          type: value?.type === 'region' ? 'eventType' : 'event',
          event: eventNameVal,
          eventType: newEventType,
        };
        onChange(newValue);
      }}
      locale={locale}
      globalMsg={getLocalText('event_selector_global_message', {}, false)}
      regionCountry={formatEventData(options)}
    />

  </div>;

};

